import React, {useCallback, useEffect, useState, useMemo} from "react";
import SummaryRegisteredData from "../../components/BeneficiaryDataLoader/SummaryRegisteredData/SummaryRegisteredData";
import { DimensionamentoService } from "../../services/DimensionamentoServices";
import MapUfs from "./MapUfs";
import CustomizedSteppers from "../../components/Stepper/CustomizedSteppers";
import logoDimensionamento from "../../assets/img/logoDimensionamento.svg";
import EmptyDashboard from "./EmptyDashboard";
import DashboardLoading from "../../components/Loading/DashboardLoading";

const Dashboard = () => {
  const [beneficiariosDemografico, setBeneficiariosDemografico] =
    useState(null);
  const [loading, setLoading] = useState(true);
  const [navigation, setNavigation] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  const [selectedVariable, setSelectedVariable] = useState("")
  const [selectedCity, setSelectedCity] = useState("")

  const [tableLock, setTableLock] = useState(true)
  const [search, setSearch] = React.useState("");

  const [selectedState, setSelectedState] = useState("PR")


  const fetchData = useCallback(() => {
    setLoading(true);

    DimensionamentoService.getBeneficiariosDemografico()
      .then((response) => {
        if (response && response.valuesHealthRegion !== null) {
          setBeneficiariosDemografico(response);
          if (response["valuesMacro"]) {
            setSelectedVariable("total");
            let totalArray = ["Total"];
            response["valuesMacro"].forEach((item) => {
              item.forEach((value, col) => {
                if (totalArray[col + 1] === undefined) totalArray[col + 1] = 0;
                totalArray[col + 1] += parseFloat(value);
              });
            });
            setSelectedCity(totalArray);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao carregar dados:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const progressStats = useMemo(() => {
    if (!navigation || navigation.length === 0) {
      return { percent: 0, completed: 0, total: 0 };
    }

    const notOptionalSteps = navigation.filter((step) => !step.optional);
    const completedSteps = notOptionalSteps.filter(
      (step) => step.completed
    ).length;
    const totalSteps = notOptionalSteps.length;
    const percent =
      totalSteps > 0 ? Math.round((completedSteps / totalSteps) * 100) : 0;

    return {
      percent,
      completed: completedSteps,
      total: totalSteps,
    };
  }, [navigation]);

  return (
    <div className={`w-full flex flex-col justify-center items-center overflow-x-hidden h-full ${
      progressStats.percent < 100 ? 'overflow-y-auto' : 'overflow-y-hidden'
    }`}>
      {loading ? (
        <div className="w-full">
          <div className="md:px-8 px-4 mt-4 flex-1 w-full overflow-y-hidden overflow-x-hidden bg-[#fff] flex flex-col text-secondary justify-between max-h-[95vh]">
            <div className="w-full pl-4 md:pl-0">
              <CustomizedSteppers
                navigation={navigation}
                activeStep={activeStep}
                setNavigation={setNavigation}
                setActiveStep={setActiveStep}
              />
            </div>
          </div>
          <DashboardLoading />
        </div>
      ) : beneficiariosDemografico ? (
        <>
          <div className="md:px-8 px-4 mt-4 flex-1 w-full overflow-y-hidden overflow-x-hidden bg-[#fff] flex flex-col text-secondary justify-between max-h-[95vh]">
            <div className="w-full pl-4 md:pl-0">
              <CustomizedSteppers
                navigation={navigation}
                activeStep={activeStep}
                setNavigation={setNavigation}
                setActiveStep={setActiveStep}
              />
            </div>
          </div>
          {progressStats.percent < 100 && (
            <div className="w-full max-w-4xl mx-auto my-6 px-4">
              <div className="bg-white rounded-lg shadow-lg p-6 border border-emerald-100 hover:shadow-xl transition-shadow duration-300">
                <div className="flex flex-col md:flex-row items-center">
                  <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
                    <div className="relative w-36 h-36 group cursor-pointer">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <svg
                          className="absolute"
                          width="100%"
                          height="100%"
                          viewBox="0 0 120 120"
                        >
                          <circle
                            cx="60"
                            cy="60"
                            r="54"
                            fill="none"
                            stroke="#f3f4f6"
                            strokeWidth="10"
                          />
                        </svg>

                        <div className="absolute inset-0 bg-emerald-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur-xl"></div>

                        <svg
                          className="absolute"
                          width="100%"
                          height="100%"
                          viewBox="0 0 120 120"
                        >
                          <circle
                            cx="60"
                            cy="60"
                            r="54"
                            fill="none"
                            stroke="#368C5D"
                            strokeWidth="10"
                            strokeDasharray={`${
                              (progressStats.percent * 339.292) / 100
                            } 339.292`}
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            transform="rotate(-90 60 60)"
                            className="transition-all duration-1000 ease-out"
                            style={{
                              filter:
                                "drop-shadow(0px 0px 3px rgba(54, 140, 93, 0.5))",
                            }}
                          />
                        </svg>

                        <img
                          src={logoDimensionamento}
                          alt="Logo Dimensionamento"
                          className="z-10 w-28 h-28 transition-all duration-500 group-hover:scale-110"
                          style={{
                            opacity: 0.5 + progressStats.percent / 200,
                            filter: `saturate(${
                              50 + progressStats.percent / 2
                            }%)`,
                          }}
                        />
                      </div>

                      <div className="absolute inset-0 flex items-center justify-center z-10">
                        <div className="text-xl font-bold text-emerald-700 bg-white bg-opacity-70 rounded-full h-12 w-12 flex items-center justify-center group-hover:scale-110 transition-transform">
                          {progressStats.percent}%
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="md:w-2/3 md:pl-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">
                      Progresso da Coleta de Dados
                    </h2>
                    <p className="text-gray-600 mb-4">
                      Você concluiu{" "}
                      <span className="font-semibold text-emerald-700">
                        {progressStats.completed} de {progressStats.total}
                      </span>{" "}
                      etapas da pesquisa. Continue avançando para visualizar os
                      resultados completos.
                    </p>

                    <div className="w-full bg-gray-200 rounded-full h-3 mb-1">
                      <div
                        className="bg-gradient-to-r from-emerald-400 to-emerald-700 h-3 rounded-full transition-all duration-1000 ease-out"
                        style={{
                          width: `${progressStats.percent}%`,
                          boxShadow: "0 0 8px rgba(54, 140, 93, 0.5)",
                        }}
                      ></div>
                    </div>

                    <div className="w-full flex justify-between items-center pt-1">
                      <div className="flex flex-col items-center">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            progressStats.percent > 0
                              ? "bg-emerald-600"
                              : "bg-gray-300"
                          } transition-colors duration-500`}
                        ></div>
                        <span className="text-xs mt-1">Início</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            progressStats.percent >= 33
                              ? "bg-emerald-600"
                              : "bg-gray-300"
                          } transition-colors duration-500`}
                        ></div>
                        <span className="text-xs mt-1">33%</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            progressStats.percent >= 66
                              ? "bg-emerald-600"
                              : "bg-gray-300"
                          } transition-colors duration-500`}
                        ></div>
                        <span className="text-xs mt-1">66%</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            progressStats.percent >= 100
                              ? "bg-emerald-600"
                              : "bg-gray-300"
                          } transition-colors duration-500`}
                        ></div>
                        <span className="text-xs mt-1">Completo</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <h1 className="text-center text-2xl font-semibold py-4">
            Distribuição dos{" "}
            <span className="text-emerald-700">Beneficiarios</span>
          </h1>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 w-full max-w-[1600px] px-4 mx-auto mb-5 items-stretch">
            <div className="w-full h-[85vh] md:h-[70vh] flex flex-col border rounded-lg shadow-lg">
              <MapUfs
                  beneficiariosDemo={beneficiariosDemografico}
                  search={search}
                  setSearch={setSearch}
                  tableSetter={setTableLock}
                  regionInputDataSetter={setSelectedCity}
                  selectedCity={selectedCity}
                  setSelectedVariable={setSelectedVariable}
                  setSelectedState={setSelectedState}
                  selectedState={selectedState}
              />
            </div>
            <div className="w-full h-[95vh] md:h-[70vh] flex flex-col border rounded-lg shadow-lg">
              <div className="flex flex-row py-6 px-12 justify-center items-center">
                <h1 className="text-xl">
                  Beneficiarios por <span className="text-emerald-700">Região</span>
                </h1>
              </div>
              <div className="flex-grow px-4 pb-4 overflow-y-auto">
                <SummaryRegisteredData
                    beneficiaryData={beneficiariosDemografico}
                    selectedVariable={selectedVariable}
                    selectedCity={selectedCity}
                    tableLock={tableLock}
                    search={search}
                    selectedState={selectedState}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <EmptyDashboard
          navigation={navigation}
          activeStep={activeStep}
          setNavigation={setNavigation}
          setActiveStep={setActiveStep}
          logoDimensionamento={logoDimensionamento}
          progressStats={progressStats}
        />
      )}
    </div>
  );
};

export default Dashboard;
